import { useTranslation } from 'react-i18next';
import { PublicLayout } from '@/components/layout';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-dark-800 dark:text-white mb-8">
          {t('privacyPage.title')}
        </h1>

        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.introTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.introP1')}
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('privacyPage.introP2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.controllerTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.controllerDescription')}
            </p>
            <ul className="list-none text-gray-600 dark:text-gray-300 mt-3 space-y-1">
              <li><strong>{t('privacyPage.controllerCompanyName')}</strong> Scalab Games</li>
              <li><strong>{t('privacyPage.controllerAddress')}</strong> 160 Avenue de Fès, 34080 Montpellier, France</li>
              <li><strong>{t('privacyPage.controllerEmail')}</strong> <a href="mailto:contact@scalab-games.com" className="text-lime-600 hover:text-lime-700 underline">contact@scalab-games.com</a></li>
              <li><strong>{t('privacyPage.controllerSiret')}</strong> 93267579600019</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.collectedTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.collectedDescription')}
            </p>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-4 mb-2">{t('privacyPage.registrationTitle')}</h3>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-1">
              <li>{t('privacyPage.registrationItem1')}</li>
              <li>{t('privacyPage.registrationItem2')}</li>
              <li>{t('privacyPage.registrationItem3')}</li>
              <li>{t('privacyPage.registrationItem4')}</li>
              <li>{t('privacyPage.registrationItem5')}</li>
            </ul>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-4 mb-2">{t('privacyPage.usageTitle')}</h3>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-1">
              <li>{t('privacyPage.usageItem1')}</li>
              <li>{t('privacyPage.usageItem2')}</li>
              <li>{t('privacyPage.usageItem3')}</li>
            </ul>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-4 mb-2">{t('privacyPage.analyticsTitle')}</h3>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-1">
              <li>{t('privacyPage.analyticsItem1')}</li>
              <li>{t('privacyPage.analyticsItem2')}</li>
              <li>{t('privacyPage.analyticsItem3')}</li>
              <li>{t('privacyPage.analyticsItem4')}</li>
              <li>{t('privacyPage.analyticsItem5')}</li>
            </ul>

            <h3 className="text-lg font-medium text-dark-800 dark:text-white mt-4 mb-2">{t('privacyPage.technicalTitle')}</h3>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-1">
              <li>{t('privacyPage.technicalItem1')}</li>
              <li>{t('privacyPage.technicalItem2')}</li>
              <li>{t('privacyPage.technicalItem3')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.purposeTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.purposeDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('privacyPage.purposeItem1Label')}</strong> : {t('privacyPage.purposeItem1Text')}</li>
              <li><strong>{t('privacyPage.purposeItem2Label')}</strong> : {t('privacyPage.purposeItem2Text')}</li>
              <li><strong>{t('privacyPage.purposeItem3Label')}</strong> : {t('privacyPage.purposeItem3Text')}</li>
              <li><strong>{t('privacyPage.purposeItem4Label')}</strong> : {t('privacyPage.purposeItem4Text')}</li>
              <li><strong>{t('privacyPage.purposeItem5Label')}</strong> : {t('privacyPage.purposeItem5Text')}</li>
              <li><strong>{t('privacyPage.purposeItem6Label')}</strong> : {t('privacyPage.purposeItem6Text')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.legalBasisTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.legalBasisDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('privacyPage.legalBasisItem1Label')}</strong> : {t('privacyPage.legalBasisItem1Text')}</li>
              <li><strong>{t('privacyPage.legalBasisItem2Label')}</strong> : {t('privacyPage.legalBasisItem2Text')}</li>
              <li><strong>{t('privacyPage.legalBasisItem3Label')}</strong> : {t('privacyPage.legalBasisItem3Text')}</li>
              <li><strong>{t('privacyPage.legalBasisItem4Label')}</strong> : {t('privacyPage.legalBasisItem4Text')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.recipientsTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.recipientsDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('privacyPage.recipientsItem1Label')}</strong> : {t('privacyPage.recipientsItem1Text')}</li>
              <li><strong>{t('privacyPage.recipientsItem2Label')}</strong> : {t('privacyPage.recipientsItem2Text')}</li>
              <li><strong>{t('privacyPage.recipientsItem3Label')}</strong> : {t('privacyPage.recipientsItem3Text')}</li>
            </ul>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('privacyPage.recipientsDisclaimer')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.transfersTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.transfersP1')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.retentionTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.retentionDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('privacyPage.retentionItem1Label')}</strong> : {t('privacyPage.retentionItem1Text')}</li>
              <li><strong>{t('privacyPage.retentionItem2Label')}</strong> : {t('privacyPage.retentionItem2Text')}</li>
              <li><strong>{t('privacyPage.retentionItem3Label')}</strong> : {t('privacyPage.retentionItem3Text')}</li>
              <li><strong>{t('privacyPage.retentionItem4Label')}</strong> : {t('privacyPage.retentionItem4Text')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.rightsTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.rightsDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li><strong>{t('privacyPage.rightsItem1Label')}</strong> : {t('privacyPage.rightsItem1Text')}</li>
              <li><strong>{t('privacyPage.rightsItem2Label')}</strong> : {t('privacyPage.rightsItem2Text')}</li>
              <li><strong>{t('privacyPage.rightsItem3Label')}</strong> : {t('privacyPage.rightsItem3Text')}</li>
              <li><strong>{t('privacyPage.rightsItem4Label')}</strong> : {t('privacyPage.rightsItem4Text')}</li>
              <li><strong>{t('privacyPage.rightsItem5Label')}</strong> : {t('privacyPage.rightsItem5Text')}</li>
              <li><strong>{t('privacyPage.rightsItem6Label')}</strong> : {t('privacyPage.rightsItem6Text')}</li>
              <li><strong>{t('privacyPage.rightsItem7Label')}</strong> : {t('privacyPage.rightsItem7Text')}</li>
            </ul>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('privacyPage.rightsContact')} <a href="mailto:contact@scalab-games.com" className="text-lime-600 hover:text-lime-700 underline">contact@scalab-games.com</a>
            </p>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mt-3">
              {t('privacyPage.rightsCnil')} <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-lime-600 hover:text-lime-700 underline">www.cnil.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.securityTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.securityDescription')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mt-3 space-y-2">
              <li>{t('privacyPage.securityItem1')}</li>
              <li>{t('privacyPage.securityItem2')}</li>
              <li>{t('privacyPage.securityItem3')}</li>
              <li>{t('privacyPage.securityItem4')}</li>
              <li>{t('privacyPage.securityItem5')}</li>
              <li>{t('privacyPage.securityItem6')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.cookiesSectionTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.cookiesSectionText')}{' '}
              <a href="/cookies" className="text-lime-600 hover:text-lime-700 underline">{t('privacyPage.cookiesSectionLinkText')}</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.minorsTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.minorsText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.changesTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.changesText')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-dark-800 dark:text-white mb-3">
              {t('privacyPage.contactTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('privacyPage.contactText')} <a href="mailto:contact@scalab-games.com" className="text-lime-600 hover:text-lime-700 underline">contact@scalab-games.com</a>
            </p>
          </section>
        </div>

        <p className="text-sm text-gray-500 dark:text-gray-400 mt-12">
          {t('privacyPage.lastUpdated')}
        </p>
      </div>
    </PublicLayout>
  );
};

export default Privacy;
